import { Divider, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { pricingBinder } from "libs/analytics/binders/onboarding/pricing";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { Fragment, useEffect } from "react";
import { Title } from "../Title";
import { AccommodationCategoryEnum } from "../constants/accommodationCategoryEnum.ts";
import { useMetadataAtomValue } from "../metadataAtom";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useAccommodationCategory } from "../useAccommodationCategory.ts";
import { PayoutHeader } from "./PayoutHeader";
import { RateController } from "./RateController";
import { WeeklyMonthly } from "./WeeklyMonthly";
import { First3BookingController } from "./discounts/First3BookingController";
import { PayoutController } from "./payout/PayoutController";

export const PricingPage = () => {
    const {
        cmsData: {
            pricing: { pricing, boostBookingsWithDiscounts },
        },
    } = useStaticDataAtomValue();
    const {
        experimentsAtom: { isConvergencePricing },
    } = useMetadataAtomValue();
    const { hasAccommodationTypes } = useAccommodationCategory();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(pricingBinder);

    const isHotel = hasAccommodationTypes(AccommodationCategoryEnum.Hotel, AccommodationCategoryEnum.MultipleNha);

    return (
        <VStack gap="24" pb="32">
            <Title title={pricing} />
            {!(isConvergencePricing && isHotel) && (
                <Fragment>
                    <RateController />
                    <Divider />
                    <Typography variant="heading-default">{boostBookingsWithDiscounts}</Typography>
                    <First3BookingController />
                    <WeeklyMonthly />
                    <Divider />
                </Fragment>
            )}
            <PayoutHeader />
            <PayoutController />
        </VStack>
    );
};
